var map = {
	"./template.bet575": 1556,
	"./template.bet575.tsx": 1556,
	"./template.bet777": 1557,
	"./template.bet777.tsx": 1557,
	"./template.betprofessor": 1558,
	"./template.betprofessor.tsx": 1558,
	"./template.betroyale": 1559,
	"./template.betroyale.tsx": 1559,
	"./template.betstride": 1560,
	"./template.betstride.tsx": 1560,
	"./template.buffalobet": 1561,
	"./template.buffalobet.tsx": 1561,
	"./template.chromabet": 1562,
	"./template.chromabet.tsx": 1562,
	"./template.default": 669,
	"./template.default.tsx": 669,
	"./template.epicodds": 1563,
	"./template.epicodds.tsx": 1563,
	"./template.fiestabet": 1564,
	"./template.fiestabet.tsx": 1564,
	"./template.gigabet": 1565,
	"./template.gigabet.tsx": 1565,
	"./template.goldenbet888": 1566,
	"./template.goldenbet888.tsx": 1566,
	"./template.goldenrush": 1567,
	"./template.goldenrush.tsx": 1567,
	"./template.hyperbet": 1568,
	"./template.hyperbet.tsx": 1568,
	"./template.juicybet": 1569,
	"./template.juicybet.tsx": 1569,
	"./template.junglebet": 1570,
	"./template.junglebet.tsx": 1570,
	"./template.magnumbet": 1571,
	"./template.magnumbet.tsx": 1571,
	"./template.puntcity": 1572,
	"./template.puntcity.tsx": 1572,
	"./template.questbet": 1573,
	"./template.questbet.tsx": 1573,
	"./template.slambet": 1574,
	"./template.slambet.tsx": 1574,
	"./template.templebet": 1575,
	"./template.templebet.tsx": 1575,
	"./template.titanbet": 1576,
	"./template.titanbet.tsx": 1576,
	"./template.ts": 982,
	"./template.vikingbet": 1577,
	"./template.vikingbet.tsx": 1577,
	"./template.volcanobet": 1578,
	"./template.volcanobet.tsx": 1578,
	"./template.wellbet": 1579,
	"./template.wellbet.tsx": 1579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2447;